module.exports = __webpack_public_path__ + "img/05.6693cb60.png";